import React, { useState, useEffect } from "react";
import GoogleAutocomplete from "react-google-autocomplete";
import styles from "./styles.module.scss";
import MessageBox from "reusableComponents/MessageBox";

const GoogleAutocompleteWrapper = ({
  label,
  required,
  apiKey,
  handleAddressSelect,
  error,
  savedAddress,
  t,
}) => {
  const [address, setAddress] = useState("");

  // Initialize address when savedAddress is available
  useEffect(() => {
    if (savedAddress) {
      setAddress(savedAddress);
    }
  }, [savedAddress]);

  // Don't render if API key is missing
  if (!apiKey) {
    return (
      <div className={styles.googleAutocomplete}>
        <label htmlFor="google-autocomplete-input" className={styles.label}>
          {label}
          {required && <span className={styles.required}>{`(*)`}</span>}
        </label>
        <input
          type="text"
          className={`${styles.input} ${error ? styles.inputError : ""} ${styles.disabledInput}`}
          placeholder="Google Maps API key is missing"
          disabled
          value={address}
          onChange={(e) => setAddress(e.target.value)}
        />
        {error && <MessageBox type="error" message={error} />}
      </div>
    );
  }

  return (
    <div className={styles.googleAutocomplete}>
      <label htmlFor="google-autocomplete-input" className={styles.label}>
        {label}
        {required && <span className={styles.required}>{`(*)`}</span>}
      </label>
      <GoogleAutocomplete
        id="google-autocomplete-input"
        apiKey={apiKey}
        onPlaceSelected={(place) => {
          if (place && place.formatted_address) {
            setAddress(place.formatted_address);
            handleAddressSelect(place.formatted_address);
          }
        }}
        value={address}
        onChange={(e) => setAddress(e.target.value)}
        options={{ 
          types: ["address"],
          fields: ["formatted_address", "geometry", "address_components", "name"]
        }}
        className={`${styles.input} ${error ? styles.inputError : ""}`}
        // placeholder={t?.("provide.step1.address.streetPlaceholder") || "Enter address"}
      />
      {error && <MessageBox type="error" message={error} />}
    </div>
  );
};

export default GoogleAutocompleteWrapper;